import { isGlobalSettingsMailbox } from 'owa-account-source-list-store';
import { addSetAccountConfigurationLog } from 'owa-account-user-configuration-monitor/lib/addSetAccountConfigurationLog';
import type { MailboxInfo } from 'owa-client-types';
import { getAccountKeyForMailboxInfo } from 'owa-client-types';
import type OwaUserConfiguration from 'owa-service/lib/contract/OwaUserConfiguration';
import { mutatorAction } from 'satcheljs';
import { getRawStoreInternalOnly } from '../store/store';
import type { AccountConfigurationOrigin } from '../types/AccountConfigurationOrigin';
import { logSetAccountConfiguration } from '../utils/logSetAccountConfiguration';
import { makeAdditionalAccountConfiguration } from '../utils/makeAdditionalAccountConfiguration';
import { userConfigurationSet } from './userConfigurationSet';

/* eslint-disable-next-line owa-custom-rules/require-add-identifier-to-mutator-action-variables -- (https://aka.ms/OWALintWiki)
 * Mutator action variables should end with 'Mutator' so that we can more easily identify potential misuses of it.
 *	> Please add 'Mutator' substring add the end of the mutator action variable name. */
const setAccountConfigurationInternal = mutatorAction(
    'setAccountConfigurationInternal',
    (
        mailboxInfo: MailboxInfo,
        userConfiguration: OwaUserConfiguration,
        forceIsGlobalAccountMailboxInfoResult: boolean
    ): void => {
        const store = getRawStoreInternalOnly();

        const additionalAccountProps = makeAdditionalAccountConfiguration(userConfiguration);
        const config = {
            ...userConfiguration,
            ...additionalAccountProps,
        };

        addSetAccountConfigurationLog(
            forceIsGlobalAccountMailboxInfoResult,
            isGlobalSettingsMailbox(mailboxInfo),
            userConfiguration
        );

        if (forceIsGlobalAccountMailboxInfoResult /*isGlobalSettingsMailbox(mailboxInfo)*/) {
            store.userConfiguration = config;
        } else {
            const accountKey = getAccountKeyForMailboxInfo(mailboxInfo);
            store.nonGlobalAccountDataMap.set(accountKey, config);
        }

        // An aggregate map is also maintained with a merged view of all folder id name mappings for all accounts.
        const currentMap = store.defaultFolderIdToNameMap;
        store.defaultFolderIdToNameMap = new Map([
            ...currentMap,
            ...additionalAccountProps.defaultFolderIdToNameMap,
        ]);
    }
);

export const setAccountConfiguration = (
    configurationOrigin: AccountConfigurationOrigin,
    mailboxInfo: MailboxInfo,
    userConfiguration: OwaUserConfiguration,
    forceIsGlobalAccountMailboxInfoResult: boolean
): void => {
    logSetAccountConfiguration(
        configurationOrigin,
        mailboxInfo,
        forceIsGlobalAccountMailboxInfoResult
    );

    setAccountConfigurationInternal(
        mailboxInfo,
        userConfiguration,
        forceIsGlobalAccountMailboxInfoResult
    );

    if (forceIsGlobalAccountMailboxInfoResult /*isGlobalSettingsMailbox(mailboxInfo)*/) {
        const globalConfig = getRawStoreInternalOnly().userConfiguration;
        if (globalConfig) {
            userConfigurationSet(globalConfig);
        }
    } else {
        const accountKey = getAccountKeyForMailboxInfo(mailboxInfo);
        const accountConfig = getRawStoreInternalOnly().nonGlobalAccountDataMap.get(accountKey);
        if (accountConfig) {
            userConfigurationSet(accountConfig, accountKey, mailboxInfo);
        }
    }
};
